import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';

import parse from 'html-react-parser';

import { getTokenInfo } from '../../../UseToken';
import { reqGET } from '../../../Utils';

import Loader from '../../Loader/Loader';

import { language } from './Language';

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {

	const [lang, ] = useState('pt');

    const [dados, set_dados] = useState(data_interface);

    const [entries, set_entries] = useState([]);
    const [equipments, set_equipments] = useState([]);
    const [classes, set_classes] = useState([]);
    const [activities, set_activities] = useState([]);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

     // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(async res => {

                if(res.data !== undefined && res.data.length > 0) {
                    set_dados(res.data[0])

                }

            })
            .catch(() => 404
                //  TODO: ENVIAR PÃ�GINA 404
                //  alert(error)); 
            );
    }

    let translate = (key_list, lang) => {
        let res = ''
        // console.log('Translate:',key_list,':',lang,'=', res)
        try {
            res = key_list.filter(e => e[lang])[0][lang]
            return res
        } 
        catch (error) {
            return res
        }	
    }

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id'])
                .then(() => setLoading(false))

        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);

    return (isRedirect ?
            <Redirect to={endpoints.list} replace />
        :
            isloading ?
                <Loader />
            :
                <main>
                    <div className={`dash-cards header`}>
                        <div className='container'>
                            <h2 className="dash-title">{language[lang].component}</h2>
                            <p>{language[lang].component}</p>
                        </div>
                    </div>

                    <div className={`dash-cards body`}>
                        <div className="container">
                            <div className="row">
            
                                <div className="mb-5 mb-xl-10">
                                    <div className='card'>

                                        <div id="div-content">

                                            <div className="card-body p-4">
                                                <div className='tab-content'>

                                                    <div className="tab-pane show active" role="tabpanel">
                                                        <div className='col-12'>
                                                            <div className="row">
                                                                <div className="col-12 col-sm-10 offset-sm-1 mt-3">
                                                                    <div className='row'>
                                                                        <div className="col-12">
                                                                            <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_n_encomenda}</label>
                                                                            {dados.id}
                                                                        </div>
                                                                        <div className='col-12'>
                                                                            <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_name}</label>
                                                                            {dados.info.documento.user_info.name}
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].numero_licenca}</label>
                                                                            {dados.info.documento.user_info.numero_licenca}
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_clube}</label>
                                                                            {dados.info.documento.user_info.clube}
                                                                        </div>
                                                                        
                                                                        {
                                                                        (getTokenInfo().profile === 'Gestor de Conteúdos' || getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'Cliente') ?
                                                                            <>
                                                                                <div className="col-12">
                                                                                    <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_email}</label>
                                                                                    {dados.info.documento.user_info.contacts[0].email}
                                                                                </div>
                                                                                <div className="col-12">
                                                                                    <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_vat}</label>
                                                                                    {dados.info.documento.user_info.vat}
                                                                                </div>
                                                                            </>
                                                                        :
                                                                            null
                                                                        }

                                                                        <div className="col-12">
                                                                            <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_date}</label>
                                                                            {dados.info.timestamp.split('T')[0]} {dados.info.timestamp.split('T')[1].split(':')[0] + ':' + dados.info.timestamp.split('T')[1].split(':')[1]}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className='col-12 col-sm-8 offset-sm-2 mb-6 p-5'>
                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr>
                                                                                <td style={{width: '75%'}}><strong>Designação</strong></td>
                                                                                <td align="center"><strong>Qtd</strong></td>
                                                                                {
                                                                                (getTokenInfo().profile === 'Gestor de Conteúdos' || getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'Cliente') ?
                                                                                    <>
                                                                                        <td align="right" className='d-none' style={{width: '120px'}}><strong>Preço unitário</strong></td>
                                                                                        <td align="right" className='d-none' style={{width: '80px'}}><strong></strong></td>
                                                                                        <td align="right" style={{width: '120px'}}><strong>Preço total</strong></td>
                                                                                    </>
                                                                                :
                                                                                    null
                                                                                }
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                            dados.info.documento.linhas.map((el, k) => {
                                                                                return (
                                                                                    <tr key={k}>
                                                                                    <td className='align-middle'>
                                                                                        <strong>{el.designacao}</strong> {el.category !== '' ? el.category : ''}
                                                                                        <br />
                                                                                        {el.observation !== '' ? <>{el.observation} {parse('&nbsp;&nbsp;&nbsp;')}</> : ''}
                                                                                    </td>
                                                                                    <td className="align-middle" align="center" style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>{el.quantidade}</td>
                                                                                        {
                                                                                        (getTokenInfo().profile === 'Gestor de Conteúdos' || getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'Cliente') ?
                                                                                            <>
                                                                                                <td className="align-middle d-none" align="right" style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>{parseFloat(parseFloat(el.total_liquido) / parseInt(el.quantidade)).toFixed(2)} €</td>
                                                                                                <td className="align-middle d-none" align="right" style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>{parseFloat(el.taxa_iva).toFixed(0)} %</td>
                                                                                                <td className="align-middle" align="right" style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>{parseFloat(el.total_liquido).toFixed(2)} €</td>
                                                                                            </>
                                                                                        :
                                                                                            null
                                                                                        }
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            }
                                                                        </tbody>
                                                                        <tfoot>
                                                                            {
                                                                            (getTokenInfo().profile === 'Gestor de Conteúdos' || getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'Cliente') ?
                                                                                <>
                                                                                    <tr className='d-none'>
                                                                                        <td></td>
                                                                                        <td></td>
                                                                                        <td className='d-none'></td>
                                                                                        <td align="right"><strong>Total Iliquido</strong></td>
                                                                                        <td align="right" style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>{parseFloat(dados.info.documento.total_iliquido_documento).toFixed(2)} €</td>
                                                                                    </tr>
                                                                                    <tr className='d-none'>
                                                                                        <td></td>
                                                                                        <td></td>
                                                                                        <td className='d-none'></td>
                                                                                        <td align="right"><strong>IVA</strong></td>
                                                                                        <td align="right" style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>{parseFloat(dados.info.documento.total_iva_documento).toFixed(2)} €</td>
                                                                                    </tr>
                                                                                    <tr className='border-0'>
                                                                                        <td className='border-0'></td>
                                                                                        <td className='d-none'></td>
                                                                                        <td className='d-none'></td>
                                                                                        <td className='border-0' align="right"><strong>Total</strong></td>
                                                                                        <td className='border-0' align="right" style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>{parseFloat(dados.info.documento.total_documento).toFixed(2)} €</td>
                                                                                    </tr>
                                                                                </>
                                                                            :
                                                                                null
                                                                            }
                                                                        </tfoot>
                                                                    </table>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className={'dash-cards footer'}>
                        <nav className="navbar bottom-navbar navbar-light">
                            <div className="navbar-footer">
                                <ul className="navbar-nav float-left"></ul>
                                <ul className="navbar-nav float-right">
                                    <li className="nav-item">
                                        <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </main>
    )
}